import { mergeStyles } from "office-ui-fabric-react";

export const margin = mergeStyles({
    marginTop: 15
  })
  
  export const btnContainer = mergeStyles({
    display: "flex",
  })